import * as XLSX from 'xlsx'

export const BATCH_IMPORT_COLUMNS = [
    { key: 'empNo', header: 'Staff ID / Service No *' },
    { key: 'amount', header: 'Amount (Optional override)' },
    { key: 'percentage', header: 'Percentage (Optional override)' },
    { key: 'overrideReason', header: 'Override Reason' },
    { key: 'remarks', header: 'Remarks' },
];

export const downloadBatchEmployeeTemplate = (batch) => {
  const isFixed = batch?.calculationMethod === "Fixed" || batch?.calculationMethod === "F";
  const valueColumn = isFixed ? 'Amount (Rs.)' : 'Percentage';

  const headers = ['Staff ID', valueColumn, 'Override Reason', 'Remarks']

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet([headers]);

  ws['!cols'] = [{ wch: 15 }, { wch: 15 }, { wch: 30 }, { wch: 30 }];

  XLSX.utils.book_append_sheet(wb, ws, 'Template');
  XLSX.writeFile(wb, `${batch?.batchNo || 'Batch'}_Template.xlsx`);
};

export const readBatchWorkbook = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
        
        // Inject row numbers for error reporting (+2 because of 0-index and header row)
        const withRows = jsonData.map((row, index) => ({
          ...row,
          _row: index + 2,
        }));
        
        resolve(withRows);
      } catch (err) {
        reject(new Error('Failed to parse the Excel file.'));
      }
    };
    reader.onerror = () => reject(new Error('Failed to read the file.'));
    reader.readAsArrayBuffer(file);
  });
};

export const validateBatchRow = (rawRow, employeeMap, existingBatchEmpNos, batch) => {
  const errors = [];
  const values = {};

  const isFixed = batch?.calculationMethod === 'Fixed' || batch?.calculationMethod === 'F';
  
  // 1. Fuzzy match the keys to handle slight changes in Excel header names or trailing spaces
  const keys = Object.keys(rawRow);
  
  const staffIdKey = keys.find(k => k.toLowerCase().includes('staff id')) || 'Staff ID';
  const overrideKey = keys.find(k => k.toLowerCase().includes('override')) || 'Override Reason';
  const remarksKey = keys.find(k => k.toLowerCase().includes('remarks')) || 'Remarks';

  let valueColumnHeader;
  if (isFixed) {
    valueColumnHeader = keys.find(k => k.toLowerCase().includes('amount')) || 'Amount (Rs)';
  } else {
    valueColumnHeader = keys.find(k => k.toLowerCase().includes('percent')) || 'Percentage';
  }

  // 2. Validate Staff ID
  const empNo = String(rawRow[staffIdKey] || '').trim();
  values.empNo = empNo;

  if (!empNo) {
    errors.push("Staff ID is required.");
  } else {
    if (!employeeMap[empNo.toLowerCase()]) {
      errors.push(`Employee '${empNo}' not found in the system.`);
    }
    if (existingBatchEmpNos.has(empNo.toLowerCase())) {
      errors.push(`Employee '${empNo}' is already active in this batch.`);
    }
  }

  // 3. Extract Amount / Percentage
  const rawValue = rawRow[valueColumnHeader];
  
  if (rawValue !== undefined && rawValue !== '') {
    const numericValue = Number(rawValue);
    if (Number.isNaN(numericValue)) {
      errors.push(`Invalid number format for ${valueColumnHeader}.`);
    } else {
      if (isFixed) {
        values.amount = numericValue;
      } else {
        values.percentage = numericValue;
      }
    }
  }

  // 4. Extract Optional Fields
  values.overrideReason = String(rawRow[overrideKey] || '').trim();
  values.remarks = String(rawRow[remarksKey] || '').trim();

  return { values, errors };
};